<div
  class="event-notification border-radius"
  [class.event-notification_renderred]="isRenderred"
  [@slideInOut]="visible ? 'visible' : 'hidden'"
>
  <a class="event-notification__close" (click)="onCloseNotification()">
    <img
      src="assets/icon-close.svg"
      width="24"
      height="24"
      alt="Close icon"
      class="event-notification__close-icon"
    />
  </a>

  <div class="event-notification__container">
    <ng-container #dynamicContent></ng-container>
  </div>
</div>
